"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipTransactionSerialization = void 0;
class MembershipTransactionSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.membership_presented_timestamp = entity.membership_presented_timestamp
            ? entity.membership_presented_timestamp.getTime() * 1000000
            : undefined;
        copy.valid_membership_expiration = entity.valid_membership_expiration
            ? entity.valid_membership_expiration.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.membership_presented_timestamp = entity.membership_presented_timestamp
            ? new Date(entity.membership_presented_timestamp / 1000000)
            : undefined;
        copy.valid_membership_expiration = entity.valid_membership_expiration
            ? new Date(entity.valid_membership_expiration / 1000000)
            : undefined;
        return copy;
    }
}
exports.MembershipTransactionSerialization = MembershipTransactionSerialization;
